import { AxiosError } from 'axios'
import { publicApiClient } from '../api/apiClient'

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  username: string;
  role: string;
  message: string;
}

export interface AuthError {
  message: string;
  status: number;
}

class AuthService {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    try {
      const response = await publicApiClient.post<LoginResponse>('/auth/login', credentials);
      const data = response.data;

      // 토큰을 localStorage에 저장
      this.setToken(data.accessToken);
      this.setUserInfo({ username: data.username, role: data.role });

      return data;
    } catch (error) {
      if (error instanceof AxiosError) {
        throw {
          message: error.response?.data?.message || 'Login failed',
          status: error.response?.status || 0,
        } as AuthError;
      }
      throw {
        message: 'Network error. Please try again.',
        status: 0,
      } as AuthError;
    }
  }

  logout(): void {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_info');
  }

  setToken(token: string): void {
    localStorage.setItem('auth_token', token);
  }

  getToken(): string | null {
    return localStorage.getItem('auth_token');
  }

  setUserInfo(userInfo: { username: string; role: string }): void {
    localStorage.setItem('user_info', JSON.stringify(userInfo));
  }

  getUserInfo(): { username: string; role: string } | null {
    const userInfo = localStorage.getItem('user_info');
    return userInfo ? JSON.parse(userInfo) : null;
  }

  isAuthenticated(): boolean {
    return this.getToken() !== null;
  }

  getAuthHeaders(): HeadersInit {
    const token = this.getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  }
}

export const authService = new AuthService();
